import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChimeraApiConfiguration {
  apiUrl!: string;
  appId!: string;
  customerId!: string;
}

export interface IChimeraApiConfigurationParams {
  apiUrl: string;
  appId: string;
  customerId: string;
}
